import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDoctor } from "../../context/DoctorSelectionContext";
import { API } from "../../api/api";
import { useHospitalContext } from "../../context/HospitalContext";
import { store } from "../../redux/store";
import * as slotActions from '../../redux/actions/slotsActions';
import * as queueActions from '../../redux/actions/queueActions';
import { FormControl } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { components } from "react-select";

const styles = {
    select: {
        container: (base) => ({
            ...base,
            // flex: 1,
            minWidth: '220px',

        }),
        control: (base) => ({
            ...base,
            border: '1px solid #C3C3C3',
            padding: '0',
            boxShadow: 'none',
            //   height: '10px',
            minHeight: '43px',
            borderRadius: "12px",
            backgroundColor:'#F2F2F2'
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '17px',
            fontWeight: '400',
        }),
        dropdownIndicator: (base) => ({
            ...base,
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "5px",
            marginTop: '10px',
            backgroundColor: "white",
            padding: "8px",
            minWidth: '220px',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "#D3D3D3 !important"
                : state.isFocused
                    ? "#D3D3D3 !important"
                    : "transparent",
            color: state.isSelected ? "#fff" : "black",
            cursor: "pointer",
            color: 'black',
            fontSize: '13px',
            fontWeight: '300',
        }),
    },

};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <ArrowDropDownIcon size={20} />
        </components.DropdownIndicator>
    );
};

const DoctorSwitcher = () => {
    const [doctorOptions, setDoctorOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const { selectedDoctor, setSelectedDoctor } = useDoctor();
    const { selectedHospital, } = useHospitalContext();

    useEffect(() => {
        if (selectedHospital?.id) {
            getDoctors();
        }
    }, [selectedHospital?.id]);

    const getDoctors = async () => {
        try {
            if (!selectedHospital?.id) return;
            setLoading(true);

            const res = await API.get(
                `/v1/hospitals/${selectedHospital?.id}/doctors?pageNo=1&pageSize=100`
            );

            if (res?.success) {
                const formattedDoctors = (res?.data || []).map((doctor) => ({
                    label: `Dr. ${doctor.firstName} ${doctor.lastName}`,
                    value: doctor.userTenantId,
                    data: doctor,
                }));

                setDoctorOptions(formattedDoctors);
            }
        } catch (err) {
            console.log("GET DOCTORS ERROR", err);
        } finally {
            setLoading(false);
        }
    };

    const handleDoctorChange = async (selectedOption) => {
        try {

            const payload = {
                doctorId: selectedOption?.data?.userTenantId,
            };

            const res = await API.post(
                `/v1/auth/provider/change-doctor`,
                payload
            );
            if (res?.success) {
                setSelectedDoctor(selectedOption.data);
                // clear old dashboard 
                store.dispatch(slotActions.resetSlotsAction());
                store.dispatch(queueActions.resetQueueAction());

                localStorage.setItem(
                    "doctor",
                    JSON.stringify(selectedOption.data)
                );
                localStorage.setItem(
                    "token", res.data.token
                );

            }
        } catch (err) {
            console.log("CHANGE DOCTOR ERROR", err);
        }
    };

    const selectedValue = selectedDoctor
        ? {
            label: `Dr. ${selectedDoctor.firstName} ${selectedDoctor.lastName}`,
            value: selectedDoctor.userTenantId,
        }
        : null;

    return (
        <FormControl sx={{ marginRight: '12px' }}>
            <Select
                isLoading={loading}
                options={doctorOptions}
                value={selectedValue}
                onChange={handleDoctorChange}
                placeholder="Select Doctor"
                isSearchable
                MenuProps={{
                    PaperProps: {
                        sx: {
                            borderRadius: "12px",
                            mt: 2,
                            padding: "8px",
                            minWidth: '220px',
                        }
                    }
                }}
                components={{
                    DropdownIndicator,
                }}
                styles={styles.select}
                formatOptionLabel={(option) => {
                    const doctor = option.data;
                    if (!doctor) return option.label;
                    return (
                        <div>
                            <div style={{ fontWeight: 600 }}>
                                Dr. {doctor.firstName} {doctor.lastName}
                            </div>
                        </div>
                    );
                }}
            />
        </FormControl>
    );
};

export default DoctorSwitcher;